import commonConstant from '../../common/_commonConstant';

export const filterIoTPosition = devices => {
  try {
    const IN = [];
    const OUT = [];

    devices.forEach(device => {
      switch (device.buildingIotDeviceLocation) {
        case commonConstant.iotPositionIn:
          return IN.push(device);
        case commonConstant.iotPositionOut:
          return OUT.push(device);
        default:
          return;
      }
    });

    return { IN, OUT };
  } catch (e) {
    return null;
  }
};
